export function RequiredMarker() {
  return (
    <span style={{ color: "red" }}>
      * <b style={{ marginLeft: 5, fontSize: 12 }}>Required</b>
    </span>
  );
}
